<template>
  <div class='vimeo video wrapper'>
    'here'
    <LoadWhenVisible :throttle='400'>
      <VimeoPlayer ref="player" v-if="url.includes('vimeo')" :video-url='url' @ready="autoplay ? play() : ''" :options='vimeoOptions' />
    </LoadWhenVisible>
  </div>
</template>

<script setup>
import { vueVimeoPlayer as VimeoPlayer } from 'vue-vimeo-player'
import { ref } from 'vue'
  const props = defineProps({
    mute: {
        default: false,
        type: Boolean,
    },
    responsive: {
        default: true,
        type: Boolean,
    },
    autoplay: {
        default: false,
        type: Boolean,
    },
    loop: {
        default: false,
        type: Boolean,
    },
    controls: {
        default: true,
        type: Boolean,
    },
    url: {
        type: String,
        required: true,
    },
    dnt: {
        type: Boolean,
        default: false,
        required: false,
    }
  });
  const vimeoOptions = {
    controls: props.controls,
    loop: props.loop,
    muted: props.mute,
    responsive: props.responsive,
  };
  //    autoplay: props.autoplay,
  //    playsinline: true,

  //const youtubePlayer = ref(null);
  const player = ref(null);
  const play = () => player.value.play();
  //const pause = () => youtubePlayer.value.pause();
  //defineExpose({play, pause});
</script>

<style scoped>
  div.load.when.visible > div {
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    cursor: pointer;
    overflow: hidden;
    aspect-ratio: unset;
  }

  figure :deep(iframe) {
    vertical-align: bottom;
  }
</style>

<style>

</style>
